import { AppBar, Stack, Typography, Menu, MenuItem, IconButton } from "@mui/material";
import { ReactComponent as AccountIcon } from "assets/svg/game-topbar-account.svg";
import { ReactComponent as SearchIcon } from "assets/svg/game-topbar-search.svg";
import { ReactComponent as SettingsIcon } from "assets/svg/game-topbar-settings.svg";
import { ReactComponent as WifiIcon } from "assets/svg/game-topbar-wifi.svg";
import { useGameContext, useGameRoom } from "context/GameContext";
import { useRoomTemplateLoginPageContext } from "context/RoomTemplateContext";
import format from "date-fns/format";
import { useEffect, useState } from "react";

export function GameTopbar() {
	const {
		organization: { logoURI },
	} = useGameRoom();

	const { leaveRoom } = useGameContext();
	const { value: roomTemplate } = useRoomTemplateLoginPageContext();
	const orgLogo = roomTemplate.logoURI || logoURI;

	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const handleMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	return (
		<AppBar position="sticky" sx={{ padding: "8px 16px" }} elevation={0}>
			<Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
				<IconButton id="dropdown-organization-logo" onClick={handleMenuOpen} style={{ maxHeight: 14, maxWidth: 32 }}>
					<img src={orgLogo} style={{ maxHeight: 14, maxWidth: 32 }} alt="organizationLogo" />
				</IconButton>

				<Stack direction={"row"} spacing={2} alignItems={"center"}>
					<WifiIcon />
					<SearchIcon />
					<AccountIcon />
					<SettingsIcon />
					<Clock />
				</Stack>
			</Stack>

			{/* Dropdown Menu */}
			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleMenuClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "left",
				}}
				// Add an offset for more space between the IconButton and the Menu
				PaperProps={{
					style: {
						marginTop: "16px", // Adjust the margin to control the spacing
						width: 233,
						backgroundColor: "#FFFFFF6C",
						backdropFilter: "blur(20px)",
						borderRadius: 8,
					},
				}}
			>
				{/* TODO: Implement later */}
				{/* <MenuItem onClick={handleMenuClose} sx={{ fontSize: "0.75rem", fontWeight: 500 }}>
					View Tutorial
				</MenuItem> */}
				{/* Separator */}
				<hr style={{ margin: "0 16px", border: "1px solid #3C3C432E" }} />
				<MenuItem id="option-logout" onClick={leaveRoom} sx={{ fontSize: "0.75rem", fontWeight: 500 }}>
					Logout
				</MenuItem>
			</Menu>
		</AppBar>
	);
}

// Real time clock
const Clock = () => {
	const [time, setTime] = useState(new Date());
	useEffect(() => {
		const interval = setInterval(() => setTime(new Date()), 1000);
		return () => clearInterval(interval);
	}, []);

	// Format Wed 4 Aug 2021 12:00
	const timeString = format(time, "EEE d MMM yyyy HH:mm");
	return <Typography sx={{ fontSize: "0.875rem", color: "#fff" }}>{timeString}</Typography>;
};
